export default "__VITE_ASSET__TnBjFfTF__"